module.exports = __webpack_public_path__ + "a382edfe941c9e2c9bf575b12a4da2ea.pdf";